module.exports = __webpack_public_path__ + "a65c8a7e00e6f919be7c957c7415718c.png";